import React, { useState } from 'react';
import './App.css';
import NewExpense from './components/NewExpense/NewExpense';
import Expense from './components/Expenses/Expense';
//import Signup from './components/Signup/SignUp';

const DUMMY_EXPENSES = [
  {
    id: 'e1',
    title: 'Today',
    amount: 94.12,
    date: new Date(2022, 7, 30),
  },
  { id: 'e2', title: 'New TV', amount: 799.49, date: new Date(2021, 2, 12) },
  {
    id: 'e3',
    title: 'Car Insurance',
    amount: 294.67,
    date: new Date(2022, 3, 17),
  },
  {
    id: 'e4',
    title: 'New Desk (Wooden)',
    amount: 450,
    date: new Date(2022, 9, 1),
  },
];




const App = () => {
  const [expenses, setExpenses] = useState(DUMMY_EXPENSES) 

  const addExpenseHandler = (expense) => {
    setExpenses((prevExpenses) => [expense, ...prevExpenses]);
  };  

    return (
      <div>
        <NewExpense onAddExpense = {addExpenseHandler} />
        <Expense items={expenses} />
        
      </div>
    );
}

export default App;
